import { render } from "./EstadoTicket.card.vue?vue&type=template&id=8da782b8"
import script from "./EstadoTicket.card.vue?vue&type=script&lang=js"
export * from "./EstadoTicket.card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__